import { SEP_PLAN_TAB_LABELS } from '../../../shared/AppConstants';
import { Typography } from '@mui/material';

export const getColumns = (spendTypes) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  const shouldShowPercentage = (rowId) => {
    return (
      rowId !== SEP_PLAN_TAB_LABELS.TOTAL_ROW_ID &&
      rowId !== SEP_PLAN_TAB_LABELS.SUPPLIER_STATUS_ROW_ID
    );
  };

  const formatValueWithPercentage = (value, row, spendType) => {
    if (Number.isNaN(Number(value))) {
      return '';
    }

    const formattedValue = formatter.format(value);

    if (shouldShowPercentage(row.id)) {
      const percentKey = `${spendType}_percent`;
      const percentValue = row[percentKey];
      if (percentValue !== undefined) {
        return `${formattedValue} (${percentValue}%)`;
      }
    }

    return formattedValue;
  };

  return [
    {
      field: 'rowName',
      headerName: '',
      flex: 1,
      align: 'left',
      headerAlign: 'left',
      renderCell: ({ row, value }) => {
        const indent =
          row.id === SEP_PLAN_TAB_LABELS.TOTAL_ROW_ID ||
          row.id === SEP_PLAN_TAB_LABELS.SUPPLIER_STATUS_ROW_ID
            ? 0
            : 40;
        return (
          <Typography fontWeight={700} style={{ marginLeft: indent }}>
            {value}
          </Typography>
        );
      }
    },
    ...spendTypes.map((spendType) => ({
      field: spendType,
      headerName: spendType,
      type: 'number',
      flex: 1,
      align: 'right',
      headerAlign: 'right',
      // For CSV export, return formatted value with percentage
      valueGetter: (value, row) => {
        return formatValueWithPercentage(value, row, spendType);
      },
      renderCell: ({ row }) => {
        const rawValue = row[spendType];
        const fontWeight =
          row.id === SEP_PLAN_TAB_LABELS.TOTAL_ROW_ID ? 'semibold' : 'regular';

        const displayValue = formatValueWithPercentage(
          rawValue,
          row,
          spendType
        );

        return (
          <Typography fontWeight={fontWeight} style={{ textAlign: 'right' }}>
            {displayValue}
          </Typography>
        );
      }
    }))
  ];
};
